var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    [
      _vm._v(
        "\n    " +
          _vm._s(
            _setup.numWord(_setup.props.acc.main, ["место", "места", "мест"])
          ) +
          "\n    "
      ),
      _setup.props.acc.additional
        ? [_vm._v("(+" + _vm._s(_setup.props.acc.additional) + ")")]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }